<div class="auth-container">
    <div class="row auth-main">
        <div class="col-sm-6 px-0 d-none d-sm-block">
            <div
                class="left-img"
                style="background-image: url(assets/images/pages/bg-02.png)"
            ></div>
        </div>
        <div class="col-sm-6 auth-form-section">
            <div class="form-section">
                <div class="auth-wrapper">
                    <h2 class="welcome-msg">Reset Your Password</h2>
                    <p class="auth-signup-text text-muted">
                        Enter new password to login
                    </p>
                    <form
                        class="validate-form"
                        [formGroup]="authForm"
                        (ngSubmit)="onSubmit()"
                    >
                        <div class="row">
                            <div
                                class="col-xl-12col-lg-12 col-md-12 col-sm-12 mb-2"
                            >
                                <mat-form-field
                                    class="example-full-width"
                                    appearance="outline"
                                >
                                    <mat-label>Password</mat-label>
                                    <input
                                        matInput
                                        formControlName="password"
                                        [type]="hide ? 'password' : 'text'"
                                        required
                                    />
                                    <a
                                        class="show-pwd-icon"
                                        href="#"
                                        onClick="return false;"
                                        matSuffix
                                        (click)="hide = !hide"
                                        [attr.aria-label]="'Hide password'"
                                        [attr.aria-pressed]="hide"
                                    >
                                        <mat-icon>{{
                                            hide
                                                ? "visibility_off"
                                                : "visibility"
                                        }}</mat-icon>
                                    </a>
                                    <mat-error
                                        *ngIf="
                                            authForm
                                                .get('password')
                                                .hasError('required')
                                        "
                                    >
                                        Password is required
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div
                                class="col-xl-12col-lg-12 col-md-12 col-sm-12 mb-2"
                            >
                                <mat-form-field
                                    class="example-full-width"
                                    appearance="outline"
                                >
                                    <mat-label>Confirm Password</mat-label>
                                    <input
                                        matInput
                                        formControlName="password_confirmation"
                                        [type]="chide ? 'password' : 'text'"
                                        required
                                    />
                                    <a
                                        class="show-pwd-icon"
                                        href="#"
                                        onClick="return false;"
                                        matSuffix
                                        (click)="chide = !chide"
                                        [attr.aria-label]="'Hide password'"
                                        [attr.aria-pressed]="chide"
                                    >
                                        <!-- <mat-icon> {{chide ? 'visibility_off' : 'visibility'}} </mat-icon> -->
                                    </a>
                                    <mat-error
                                        *ngIf="
                                            authForm
                                                .get('password_confirmation')
                                                .hasError('required')
                                        "
                                    >
                                        Confirm Password is required
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="flex-sb-m w-full p-b-20">
                            <div>
                                <span
                                    >Already Registered?
                                    <a routerLink="/authentication/signin">
                                        Login
                                    </a></span
                                >
                            </div>
                        </div>
                        <div
                            *ngIf="error"
                            class="alert alert-danger mt-3 mb-10"
                        >
                            {{ error }}
                        </div>
                        <div class="container-auth-form-btn">
                            <button
                                mat-flat-button
                                color="primary"
                                class="auth-form-btn"
                                [disabled]="!authForm.valid"
                                type="submit"
                            >
                                Reset Password
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
